import * as React from "react"


import { withGoogleMap, GoogleMap, Marker, withScriptjs } from "react-google-maps"
import { SprocketAsset } from "../../../types/types";

type Props = {
  lat: number,
  lng: number,
  icon: SprocketAsset
}

export default withScriptjs(withGoogleMap((props : Props) =>
  <GoogleMap
    defaultZoom={12}
    defaultCenter={{ lat: props.lat, lng: props.lng }}
  >
   <Marker position={{ lat: props.lat, lng: props.lng }} icon={props.icon.url} />
  </GoogleMap>
))
